import PropTypes from "prop-types";
import React from "react";

const Expander = ({onClick, expanded}) => {
    let className = "expander";

    if(expanded) {
        className += " expanded";
    }

    return <div onClick={onClick} className={className}>{expanded}</div>;
};

Expander.propTypes = {
    expanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default Expander;

export const ConditionalExpander = ({
    show,
    expanded,
    onClick,
}) =>
    show
        ? <Expander expanded={expanded} onClick={onClick}/>
        : <div className="expander placeholder" />;

ConditionalExpander.propTypes = {
    ...Expander.propTypes,
    show: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/validationtree/components/Expander.js